<!-- DownloadModal.vue -->
<template>
  <div id="download-modal-wrap">
    <div id="download-message">
      <h2>Thank You for Downloading!</h2>
      <p>Your download should start shortly. If not, click <a :href="directDownloadLink" target="_blank" rel="noopener noreferrer">here</a> to download directly.</p>

      <div id="download-modal-actions">
        <button @click="closeModal" class="fa-btn fa-btn-primary fa-btn-modal">Close</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useUIStore } from '@/store/uiStore';
import { ModalTypes } from '@/types/enums';

const uiStore = useUIStore();
const directDownloadLink = computed(() => uiStore.modalMessage);

const closeModal = () => {
  uiStore.setModalType(ModalTypes.INACTIVE);
};

</script>

<style scoped>
/* Add your modal styles here if necessary */
</style>
